import React from "react";
import { Clock, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";

const contactInfo = [
  {
    Icon: Phone,
    title: "Call us on",
    value: "+971 4 342 6666",
    href: "tel:+97143426666",
  },
  {
    Icon: () => (
      <svg
        className="w-5 h-5 text-green-600"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.06 22L7.31 20.62C8.76 21.41 10.37 21.82 12.04 21.82C17.5 21.82 21.95 17.37 21.95 11.91C21.95 6.45 17.5 2 12.04 2M12.04 20.13C10.56 20.13 9.12 19.74 7.84 19L7.54 18.82L4.44 19.65L5.29 16.63L5.09 16.32C4.19 14.93 3.82 13.33 3.82 11.91C3.82 7.37 7.52 3.67 12.04 3.67C14.23 3.67 16.22 4.53 17.79 6.1C19.36 7.67 20.26 9.66 20.26 11.88C20.26 16.42 16.56 20.13 12.04 20.13M16.57 14.47C16.31 14.21 15.35 13.78 15.11 13.69C14.87 13.6 14.71 13.56 14.54 13.82C14.38 14.08 13.9 14.65 13.74 14.81C13.58 14.97 13.41 15 13.15 14.74C12.89 14.48 12.11 14.21 11.22 13.4C10.54 12.78 10.09 12.06 9.93 11.8C9.77 11.54 9.89 11.42 10.02 11.29C10.13 11.18 10.27 11 10.41 10.84C10.54 10.68 10.61 10.54 10.74 10.31C10.87 10.08 10.81 9.88 10.73 9.71C10.64 9.54 10.16 8.35 9.97 7.88C9.78 7.41 9.58 7.49 9.42 7.48H9.01C8.84 7.48 8.57 7.56 8.35 7.82C8.13 8.08 7.49 8.65 7.49 9.88C7.49 11.11 8.38 12.26 8.51 12.42C8.64 12.58 10.13 14.97 12.47 15.93C14.81 16.89 14.81 16.56 15.24 16.52C15.67 16.48 16.63 15.93 16.82 15.36C17.01 14.79 17.01 14.29 16.93 14.19C16.85 14.09 16.73 14.03 16.57 14.47Z" />
      </svg>
    ),
    title: "WhatsApp",
    value: "+971 4 342 6666",
    href: "https://wa.me/97143426666",
  },
  {
    Icon: Clock,
    title: "Timing",
    value: "8am to 9pm",
  },
  {
    Icon: Mail,
    title: "Email us",
    value: "info@uberevisa.com",
    href: "mailto:info@uberevisa.com",
  },
];

export function ContactInfo() {
  return (
    <div className="space-y-1 mt-4">
      {contactInfo.map((item, index) => {
        const Wrapper: React.ElementType = item.href
          ? item.href.startsWith("http") || item.href.startsWith("mailto") || item.href.startsWith("tel")
            ? "a"
            : Link
          : "div";

        const wrapperProps =
          Wrapper === "a"
            ? { href: item.href, target: "_blank", rel: "noopener noreferrer" }
            : item.href
            ? { to: item.href }
            : {};

        return (
          <Wrapper key={index} {...wrapperProps}>
            <div className="flex items-center space-x-3 rounded-lg p-1.5 hover:bg-gray-100 transition-colors cursor-pointer">
              <div className="flex h-8 w-8 items-center justify-center rounded-md bg-gray-100 text-primary">
                <item.Icon className="w-5 h-5" />
              </div>
              <div className="flex-1">
                <p className="text-xs text-gray-500">{item.title}</p>
                <p className="font-semibold text-sm">{item.value}</p>
              </div>
            </div>
          </Wrapper>
        );
      })}
    </div>
  );
}
